import { render, staticRenderFns } from "./error.vue?vue&type=template&id=5a3c03ed&scoped=true&"
import script from "./error.vue?vue&type=script&lang=ts&"
export * from "./error.vue?vue&type=script&lang=ts&"
import style0 from "./error.vue?vue&type=style&index=0&id=5a3c03ed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c03ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/npm/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a3c03ed')) {
      api.createRecord('5a3c03ed', component.options)
    } else {
      api.reload('5a3c03ed', component.options)
    }
    module.hot.accept("./error.vue?vue&type=template&id=5a3c03ed&scoped=true&", function () {
      api.rerender('5a3c03ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/error/error.vue"
export default component.exports